import { AnimatePresence, motion } from "framer-motion";
import { ReactNode } from "react";
import { clsx } from "clsx";
import useAppSelector from "@/core/helpers/useAppSelector";
import { usePreloadImages } from "@/core/helpers/usePreloadImages";
import { imgPcMacbook } from "@/shared/assets/img";
import { pcIsShow, pcIsVisible } from "@/domains/pc/slice";
import PcBody from "@/domains/pc/components/PcBody";
import PcWrapper from "@/domains/pc/components/PcWrapper";

type Props = {
  children: ReactNode;
};

export default function PcContainer({ children }: Props) {
  const isOpen = useAppSelector(pcIsShow);
  const isVisible = useAppSelector(pcIsVisible);

  usePreloadImages([imgPcMacbook]);

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className={clsx(
            "fixed inset-y-[--boundary-offset-y] inset-x-[--boundary-offset-x] flex flex-col justify-center items-center z-40",
            { hidden: !isVisible },
          )}
          initial={{ y: "100%" }}
          animate={{ y: 0 }}
          exit={{
            y: "100%",
            transition: {
              delay: 0.2,
              stiffness: 400,
            },
          }}
          transition={{ stiffness: 400 }}
        >
          <PcWrapper>
            <PcBody>{children}</PcBody>
          </PcWrapper>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
